import { ProgressBar, Spacer, Typography } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import * as styles from "./PractitionerOnboardingStepper.styles";

interface Props {
  currentStep: number;
}

const PractitionerOnboardingStepper = ({ currentStep }: Props) => {
  const { phoneLarge } = useBreakpoints();
  const { t } = useTranslation();
  const { isCanada } = useSharedGlobalConfig();

  const NUMBER_OF_STEPS = isCanada ? 4 : 5;
  const text = `${t(l.sharedCommon.Step)} ${currentStep}/${NUMBER_OF_STEPS}`;
  const progress = Number.isFinite(currentStep)
    ? Math.max(0, Math.min(100, (currentStep / NUMBER_OF_STEPS) * 100))
    : 0;

  return (
    <div css={styles.wrapper}>
      <Typography variant="h5" isMarginless intention="neutral" colorIntensity="bold">
        <span css={styles.stepText}>{text}</span>
      </Typography>
      <Spacer size="xsmall" />
      {!!phoneLarge.greaterThan && <ProgressBar progress={progress} aria-label={text} />}
      <Spacer size={phoneLarge.greaterThan ? "large" : "medium"} />
    </div>
  );
};

export { PractitionerOnboardingStepper };
